import { URLs } from "@/configs/menu";

/** The MCP server details page's tabs, in display order. */
const MCP_SERVER_DETAILS_TABS = ["overview", "policies", "tools"] as const;

export type McpServerDetailsTab = (typeof MCP_SERVER_DETAILS_TABS)[number];

export const isMcpServerDetailsTab = (
  value: string | undefined,
): value is McpServerDetailsTab =>
  MCP_SERVER_DETAILS_TABS.includes(value as McpServerDetailsTab);

/** The tool drawer's tabs, in display order. */
const MCP_TOOL_DRAWER_TABS = [
  "toolDetails",
  "inputSchema",
  "accessRules",
] as const;

export type McpToolDrawerTab = (typeof MCP_TOOL_DRAWER_TABS)[number];

export const isMcpToolDrawerTab = (
  value: string | null | undefined,
): value is McpToolDrawerTab =>
  MCP_TOOL_DRAWER_TABS.includes(value as McpToolDrawerTab);

/** Search params that open the tool drawer over any tab of the page. */
export const TOOL_PARAM = "tool";
export const TOOL_TAB_PARAM = "toolTab";

interface McpToolDrawerTarget {
  tool?: string;
  toolTab?: McpToolDrawerTab;
}

/**
 * One MCP server's details page, opened on a tab (Overview by default) and,
 * optionally, with one tool's drawer open on top of it.
 */
export const mcpServerDetailsPath = (
  id: string,
  tab: McpServerDetailsTab = "overview",
  { tool, toolTab }: McpToolDrawerTarget = {},
): string => {
  const path = URLs.mcp_server_details_type
    .replace(":id", id)
    .replace(":type", tab);
  if (!tool) return path;
  const params = new URLSearchParams({ [TOOL_PARAM]: tool });
  if (toolTab) params.set(TOOL_TAB_PARAM, toolTab);
  return `${path}?${params.toString()}`;
};
